import { render } from "./Analyze.vue?vue&type=template&id=0a8b5b84"
import script from "./Analyze.vue?vue&type=script&lang=js"
export * from "./Analyze.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__